import "./_style.scss";
import { useContext, useEffect, useRef, useState } from "react";
import TkBackButton from "../../components/molecules/TkBackButton";
import TkFakeTable from "../../components/molecules/TkFakeTable";
import {
  Prefectures,
  SexFlug,
  TransferReason,
} from "../../assets/data/Constants";
import TkTitle from "../../components/atoms/TkTitle";
import { Box } from "@mui/material";
import { GlobalContext } from "../../context/globalContext";
import {
  fakeTableList,
  infoHeadTitleList,
  transferHeadTitleList,
} from "./parts";
import { funInfoBodyList } from "./hooks/useHooks";
import { TkGetCode } from "../../utils/TkGetCode";
import { useLocation, useNavigate } from "react-router-dom";
import { httpAPI_INQ004 } from "./api/request";
import TkSelectForm from "../../components/atoms/TkSelectForm";
import CheckBoxGroupForFakeTableLine from "../../components/atoms/TkFakeTableLine/components/checkBoxGroupForFakeTableLine";
import { changeAmountFormat } from "../../utils/useTools";
import TkTable from "../../components/atoms/TkTable";
import _ from "lodash";

/**
 * SCRC060017 職員照会
 * @return SCRC060017 職員照会
 */

const SCRC060017 = () => {
  const navigate = useNavigate();
  const { state, setState } = useContext(GlobalContext);

  const [stateTableList, setStateTableList] = useState<any>([]);
  const stateFakeTableList = useRef(_.cloneDeep(fakeTableList));
  const [baseCheckBoxList, setBaseCheckBoxList] = useState<any[]>([]);
  const location = useLocation();
  const locationState = location.state;
  const staffNo = locationState?.staffNo!;

  // 初期化
  const handleInit = async () => {
    try {
      const res = (await httpAPI_INQ004({
        contractorNo: state?.authInfo?.contractorNo!,
        staffNo: staffNo,
      })) as { [key: string]: any };

      let resArr = stateFakeTableList.current;

      if (res.resultCd === "I0000") {
        for (let i in res) {
          let targetObj = resArr.find((item) => item.keyword === i)!;
          targetObj && (targetObj.setDefaultValue = res[i]);
          if (targetObj?.type === "text") {
            if (i === "paymentAmt") {
              targetObj && (targetObj.text = changeAmountFormat(res[i]) + "円");
            } else {
              targetObj && (targetObj.text = res[i]);
            }
          }
        }

        resArr.find((item) => item.keyword === "corpAddress")!.text =
          "〒" +
          (res["cozipcode"] ?? "") +
          " " +
          TkGetCode(Prefectures, res["coprefectureCd"] ?? "") +
          (res["coaddressCity"] ?? "") +
          (res["coaddressOthers"] ?? "");

        resArr.find((item) => item.keyword === "facilityAddress")!.text =
          "〒" +
          (res["zipcode"] ?? "") +
          " " +
          TkGetCode(Prefectures, res["prefectureCd"] ?? "") +
          (res["addressCity"] ?? "") +
          (res["addressOthers"] ?? "");

        resArr.find((item) => item.keyword === "enroll")!.text =
          (res["premiumEnrollYear"] ?? 0).toString() +
          "年" +
          (res["premiumEnrollMonth"] ?? 0).toString() +
          "ヶ月";

        const yearList = res["salaryList"].map((item: any) => item.fiscalYear);
        const arrMax = function (a: any, b: any) {
          return Math.max(a, b);
        };
        const maxYear = yearList.reduce(arrMax);
        const salaryList = res["salaryList"].find(
          (item: any) => item.fiscalYear === maxYear
        )!;
        resArr.find((item) => item.keyword === "salaryTableAmt")!.text =
          changeAmountFormat(salaryList.salaryTableAmt) + "円";
        resArr.find((item) => item.keyword === "salaryAdjustmentAmt")!.text =
          changeAmountFormat(salaryList.salaryAdjustmentAmt) + "円";
        resArr.find((item) => item.keyword === "sex")!.text = TkGetCode(
          SexFlug,
          res["sex"]
        );
        resArr.find((item) => item.keyword === "sun")!.text =
          changeAmountFormat(
            (salaryList.salaryTableAmt ?? 0) +
              (salaryList.salaryAdjustmentAmt ?? 0)
          ) + "円";
        setBaseCheckBoxList(res["unrecognizedMonthList"] ?? []);

        const infoBodyList = funInfoBodyList(res["childcareLeaveList"]);
        resArr.find((item) => item.keyword === "childcareLeaveList")!.node = (
          <Box className="SCRC060017childcareLeaveList">
            <TkTable bodyList={infoBodyList} headList={infoHeadTitleList} />
          </Box>
        );
        const historyList = res["contactorTransferHistoryList"]?.sort(
          (x: any, y: any) => {
            return new Date(y.transferDate) > new Date(x.transferDate) ? 1 : -1;
          }
        );

        const transferHistoryList =
          historyList &&
          historyList.map((item: any) => [
            {
              children: TkGetCode(TransferReason, item.transferReason),
            },
            {
              children: item.transferDate,
            },
            {
              children: item.aStaffNo,
            },
            {
              children:
                (item.aContractorNo ?? "") + " " + (item.aCorpName ?? ""),
            },
            {
              children:
                (item.aFacilityNo ?? "") + " " + (item.aFacilityName ?? ""),
            },
          ]);

        resArr.find((item) => item.keyword === "transferHistoryList")!.node = (
          <Box className="SCRC060017childcareLeaveList">
            <TkTitle>{"異動履歴"}</TkTitle>
            <TkTable
              bodyList={transferHistoryList}
              headList={transferHeadTitleList}
              maxHeight={270}
              stickyHeader={true}
            />
          </Box>
        );

        setStateTableList([...resArr]);
        setState({
          ...state,
          errorMsgId: "",
        });
      } else {
        setState({
          ...state,
          errorMsgId: res.resultCd,
        });
      }
    } catch (error) {
      navigate("/error");
    }
  };

  useEffect(() => {
    handleInit();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (!baseCheckBoxList?.length) return;
    const checkBoxList = baseCheckBoxList.map((item: any) => {
      return {
        label: item.year + "年度",
        value: item.year,
      };
    });

    let resArr = stateFakeTableList.current;
    const monthList = baseCheckBoxList[0];
    const monthCheckList = [];
    for (let i in monthList) {
      if (monthList[i] === "1" || monthList[i] === "3") {
        switch (i) {
          case "apr":
            monthCheckList.push("4月");
            break;
          case "may":
            monthCheckList.push("5月");
            break;
          case "jun":
            monthCheckList.push("6月");
            break;
          case "jul":
            monthCheckList.push("7月");
            break;
          case "aug":
            monthCheckList.push("8月");
            break;
          case "sep":
            monthCheckList.push("9月");
            break;
          case "oct":
            monthCheckList.push("10月");
            break;
          case "nov":
            monthCheckList.push("11月");
            break;
          case "dec":
            monthCheckList.push("12月");
            break;
          case "jan":
            monthCheckList.push("1月");
            break;
          case "feb":
            monthCheckList.push("2月");
            break;
          case "mar":
            monthCheckList.push("3月");
            break;
        }
      }
    }

    const unrecognizedMonthList = (
      <Box>
        <Box className="part">
          <TkSelectForm
            selectPropsList={checkBoxList}
            disabled={false}
            onChange={valueChange}
            wantToSetValue={checkBoxList[0].value}
          />
        </Box>
        <Box>
          <CheckBoxGroupForFakeTableLine
            checkBoxList={[
              {
                label: "4月",
                disabled: true,
              },
              {
                label: "5月",
                disabled: true,
              },
              {
                label: "6月",
                disabled: true,
              },
              {
                label: "7月",
                disabled: true,
              },
              {
                label: "8月",
                disabled: true,
              },
              {
                label: "9月",
                disabled: true,
              },
              {
                label: "10月",
                disabled: true,
              },
              {
                label: "11月",
                disabled: true,
              },
              {
                label: "12月",
                disabled: true,
              },
              {
                label: "1月",
                disabled: true,
              },
              {
                label: "2月",
                disabled: true,
              },
              {
                label: "3月",
                disabled: true,
              },
            ]}
            wantToSetValue={monthCheckList}
          />
        </Box>
      </Box>
    );
    resArr.find((item) => item.keyword === "unrecognizedMonthList")!.node =
      unrecognizedMonthList;
    setStateTableList([...resArr]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [baseCheckBoxList]);

  const valueChange = (label: any) => {
    let resArr = stateFakeTableList.current;
    const checkBoxList = baseCheckBoxList.map((item: any) => {
      return {
        label: item.year + "年度",
        value: item.year,
      };
    });
    const selectList = baseCheckBoxList.find(
      (item: any) => item.year === label.target.value
    )!;

    const monthCheckList = [];
    for (let i in selectList) {
      if (selectList[i] === "1" || selectList[i] === "3") {
        switch (i) {
          case "apr":
            monthCheckList.push("4月");
            break;
          case "may":
            monthCheckList.push("5月");
            break;
          case "jun":
            monthCheckList.push("6月");
            break;
          case "jul":
            monthCheckList.push("7月");
            break;
          case "aug":
            monthCheckList.push("8月");
            break;
          case "sep":
            monthCheckList.push("9月");
            break;
          case "oct":
            monthCheckList.push("10月");
            break;
          case "nov":
            monthCheckList.push("11月");
            break;
          case "dec":
            monthCheckList.push("12月");
            break;
          case "jan":
            monthCheckList.push("1月");
            break;
          case "feb":
            monthCheckList.push("2月");
            break;
          case "mar":
            monthCheckList.push("3月");
            break;
        }
      }
    }

    const unrecognizedMonthList = (
      <Box>
        <Box className="part">
          <TkSelectForm
            selectPropsList={checkBoxList}
            disabled={false}
            onChange={valueChange}
            wantToSetValue={label.target.value}
          />
        </Box>
        <Box>
          <CheckBoxGroupForFakeTableLine
            checkBoxList={[
              {
                label: "4月",
                disabled: true,
              },
              {
                label: "5月",
                disabled: true,
              },
              {
                label: "6月",
                disabled: true,
              },
              {
                label: "7月",
                disabled: true,
              },
              {
                label: "8月",
                disabled: true,
              },
              {
                label: "9月",
                disabled: true,
              },
              {
                label: "10月",
                disabled: true,
              },
              {
                label: "11月",
                disabled: true,
              },
              {
                label: "12月",
                disabled: true,
              },
              {
                label: "1月",
                disabled: true,
              },
              {
                label: "2月",
                disabled: true,
              },
              {
                label: "3月",
                disabled: true,
              },
            ]}
            wantToSetValue={monthCheckList}
          />
        </Box>
      </Box>
    );
    resArr.find((item) => item.keyword === "unrecognizedMonthList")!.node =
      unrecognizedMonthList;
    setStateTableList([...resArr]);
  };
  return (
    <Box data-testid="SCRC060017PageForTest" className="SCRC060017">
      <Box className="SCRC060017staffNote">
        <TkTitle size="large">職員照会</TkTitle>
      </Box>
      <TkFakeTable
        list={stateTableList}
        ruleSchema={{}}
        showButton={false}
        buttonGroup={<TkBackButton />}
      />
    </Box>
  );
};

export default SCRC060017;
